import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  SideBarAction,
  SideBarMutation,
  SideBarState
} from "@/components/sidebar/types";
import store from "@/store";
import { Namespace } from "@/store/types";
import { AlertAction, AlertType } from "@/components/alert/types";
import apiStorageInterface from "@/services/apiStorageInterface";

const updateAppMenuItems = async (
  context: ActionContext<SideBarState, RootState>
): Promise<void> => {
  try {
    const apiStorageItemsVals = await apiStorageInterface.fetchAppMenuItems();
    context.commit(SideBarMutation.SetAppMenuItems, apiStorageItemsVals);
  } catch (error) {
    switch (error.response.status) {
      case 500:
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: "Internal server error",
          alertType: AlertType.Danger
        });
        break;
    }
  }
};

export const actions: ActionTree<SideBarState, RootState> &
  Record<SideBarAction, Action<SideBarState, RootState>> = {
  [SideBarAction.UpdateAppMenuItems]: updateAppMenuItems
};
